module.exports = __webpack_public_path__ + "static/media/download-banner-bg.d78e5034.jpg";